import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function BackButton({onBack,title}) {
  
  const navigate = useNavigate();
  const handleBack = () => {
    
    if (typeof onBack === 'function') onBack();
    else navigate(-1);
  };
  // for mobile device
  useEffect(() => {
    const onDeviceBack = (e) => {
      e.preventDefault();
      handleBack();
    };
    if (window.cordova) {
      document.addEventListener("backbutton", onDeviceBack, false);
    }

    return () => {
      if (window.cordova) {
        document.removeEventListener("backbutton", onDeviceBack, false);
      }
    };
  }, []);
  return (
    <div style={{paddingLeft:"10px"}}>
      <h5
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
          }}
          onClick={handleBack}
        >
          <span
            className="material-icons"
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              background: "#1b66d1",
              color: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "20px",
            }}
          >
            {" "}
            arrow_back{" "}
          </span>{" "}
          {title}{" "}
        </h5>
    </div>
  )
}
